export default __webpack_public_path__ + "static/media/the-best-matte-lipsticks-1558350570.d692cd0d.jpg";